// const link = "https://quasar-edtech.herokuapp.com/edtech/";
const link = "https://quasar-edtech.vercel.app/edtech/";
export default class LinkHelper {
    
    static getLink() {
        return link;
    }


}